import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,numberFormat,isFunction } from '../../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import JourneyTripActionDialog from '../../../components/Trip/JourneyTripActionDialog';
import TransactionDetailsSideBar from '../../../components/RightSideBar/TransactionDetailsSideBar';
import TripTransactionDetailsCard from '../../../components/Payment/TripTransactionDetailsCard';
import DeletePartyAdvance from '../../../components/Trip/DeletePartyAdvance';
import DeletePartyPayment from '../../../components/Trip/DeletePartyPayment';
import { CheckCircleIcon } from '@material-ui/data-grid';
import DeletePartyPaymentInitiated from '../../../components/Trip/DeletePartyPaymentInitiated';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    padding:"0 24px",
    display: 'flex',
    flexDirection:'column',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none',
    marginTop:16
  },
  box:{
    width:'100%',
  },
  listedBox:{
    '&:after':{
      content: 'adadd',
      position: 'absolute',
      top: '50%',
      left: 0,
      borderTop:' 1px solid red',
      background: 'red',
      width: '100%',
      //transform: 'translateY(-50%)',
    }
  },
  listBox:{
    width:'100%',
    backgroundColor:'#f1f1f3',
    padding:'18px 24px',
    marginTop:8,
    borderRadius:8,
    paddingRight:12,
  },
  icon:{
    fontSize:24,
    color:'#03c'
  },
  listLabel:{
    fontSize:14,
    fontWeight:'normal',
    color:'#0b1323',
    marginRight:24
  },
  amount:{
    color:'#0b1323',
    fontWeight:'normal',
    fontSize:14,
    marginRight:42,
    marginLeft:24
  },
  boxAmount:{
    color:'#0b1323',
    fontWeight:'normal',
    fontSize:14,
    marginRight:8,
  },
  sep:{
    borderTop:'1px dotted rgba(107, 119, 140, 0.25)',
    flexGrow:1,
    marginTop:5
  },
  sepIcon:{
    color:'#000',
    fontSize:6,
    opacity:0.25,
    margin:'0px 7px'
  },
  date:{
    fontSize:14,
    color:'#0b1323',
    fontWeight:600
  },
  paymentMode:{
    fontSize:14,
    color:'#0b1323',
  },
  paymentData:{
    fontSize:14,
    color:'rgba(11, 19, 35, 0.75);',
  },
  add:{
    color:'#03c',
    fontWeight:600,
    fontSize:14,
    cursor:'pointer'
  },
  lineThrough: {
    position: 'absolute', width: '100%', left: 0, borderTop: '2px solid red', top: '50%'
  },
  checkCircleIconV1: {
    color: '#008556', fontSize: 20, marginLeft: 8
  }
}));
const ColoredLine = ({ color }) => (
  <hr
      style={{
          color: color,
          backgroundColor: color,
          height: 3,
          margin:0
      }}
  />
);
const JourneyTripPaymentsCard = (props) => {
  const {trip,journey,updateJourney} = props;
  const classes = useStyles();
  let history = useHistory();
  let transactions = trip && trip.transactions && trip.transactions.payments ? trip.transactions.payments :[];
  let tripDetails = trip;
  let tripId = tripDetails && tripDetails.id ? tripDetails.id:'';
  let vehicleData = journey && journey.vehicle ? journey.vehicle : {};
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && journey && journey.vendor && journey.vendor.id ? journey.vendor.id : 0;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let partyBalance = tripDetails && tripDetails.balanceAmount ? tripDetails.balanceAmount : null;
  let vendorBalance = journey && journey.vendor && journey.vendor.vendorBalance ? journey.vendor.vendorBalance : null;
  let vendorSettled = hiredTrip && journey && journey.vendor && journey.vendor.isVendorSettled ? journey.vendor.isVendorSettled : false;
   //React State
   const [addOpen, setAddOpen] = useState(false);
   const [editOpen,setEditOpen] = useState(false);
   const [detailsOpen,setDetailsOpen] = useState(false);
   const [transactionData, setTransactionData] = useState({})
   const [deleteOpen, setDeleteOpen] = useState(false);
   const [deletePartyPaymentInitiated, setDeletePartyPaymentInitiated] = useState(false);


   let actionVisible = () => {
    if (hiredTrip) {
      return (tripStatus == 'PAYMENT_RECEIVED' && vendorSettled) ? false : true
    } else {
      return (tripStatus == 'PAYMENT_RECEIVED') ? false : true
    }
  }
  let editPartyPayment = {
    action: 'edit_party_payment',
    label: 'Update Payment',
    confirmText: 'Update Payment',
    tabsFormat: false
  }
  const [action,setAction] = useState({
    action: 'add_payment',
    label: 'Add Payment',
    visible: actionVisible(),
    eventName: 'Dweb Trip Advance Payment Initiated',
    tabsFormat: true,
    tabs: [
      {
        name: 'Party Payment',
        visible: true,
        disabled: tripStatus == 'PAYMENT_RECEIVED' ? true : false,
        person: 'party'
      },
      {
        person: 'supplier',
        visible: hiredTrip,
        disabled: vendorSettled,
        name: 'Supplier Payment'
      }
    ]
  });
  const handleActionSave = (status) => {
    /*if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }*/
  }
  const handleaddTripActionClose = (status) => {
    setAddOpen(status);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleTransactionDetailsClose = () => {
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleEditCashflowActionClose = (status) => {
    setEditOpen(status)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const handleOnUpdateSuccess = (status) => {
    setEditOpen(status);
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  }
  const onDeleteSuccess = () => {
    setDeleteOpen(false);
    setDetailsOpen(false)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    setTransactionData(null)
  }
  const onDeleteCancel = () => {
    setDeleteOpen(false);
    /*setTransactionData(null)
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }*/
  }
  const handlePaymentInitiatedClose = () => {
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }    
    setDeletePartyPaymentInitiated(false);
  }

  const handlePaymentInitiatedConfirm = () => {
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }    
    setDeletePartyPaymentInitiated(false);
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
        <Box className={classes.box} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography className={classes.listLabel}>(-) Payments</Typography>
            {transactions.totalAmount ?<div className={classes.sep}></div>:null}
            <Typography className={classes.amount}>{numberFormat(Math.abs(transactions&&transactions.totalAmount?transactions.totalAmount:0))}</Typography>
        </Box>
        {transactions && transactions.list && transactions.list.length>0 && <Box className={classes.listBox}>
          {transactions && transactions.list && transactions.list.map((trans,index)=>{
                return <Box width={'100%'} position={'relative'} textAlign={'center'}>
                    <Box component={'div'} position={'relative'} onClick={()=>{setTransactionData(trans);setDetailsOpen(true)}} width={'100%'} className={trans.paymentLinkStatus && (trans.paymentLinkStatus == "CANCELLED" || trans.paymentLinkStatus == "EXPIRED")?'payment-list-box':''} marginBottom={'12px'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                      <Box display="flex" alignItems="center">
                        <Typography className={classes.date}>{moment(Number(trans.date*1000)).format("DD MMM YY")}</Typography>
                        {trans.paymentMode && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentMode}>{trans.paymentMode}</Typography>
                        </>}
                        {trans.paymentData && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentData}>{trans.paymentData}</Typography>
                        </>}
                        {trans.paymentLinkStatus && <>
                          <FiberManualRecordIcon className={classes.sepIcon}/>
                          <Typography className={classes.paymentData}>{trans.paymentLinkStatus}</Typography>
                        </>}
                        {trans.id && trans.isBrokerEnabled &&
                          <CheckCircleIcon className={classes.checkCircleIconV1} />
                        }
                      </Box>
                      <Box display="flex" alignItems="center">
                        <Typography className={classes.boxAmount}>{numberFormat(Math.abs(trans.amount))}</Typography>
                        <ChevronRightIcon className={classes.icon}/>
                      </Box>
                    </Box>
                </Box>
            })}
             {actionVisible() && <Box className={classes.box} marginTop={'4px'}>
              <Typography onClick={()=>{setAddOpen(true)}} className={classes.add}>Add Payment</Typography>
            </Box>}
        </Box>}
        {!transactions.list && actionVisible() && <Box className={classes.box} marginTop={'8px'}>
          <Typography onClick={()=>{setAddOpen(true)}} className={classes.add}>Add Payment</Typography>
        </Box>}
      </Paper>
      {addOpen && <JourneyTripActionDialog action={action} journey={journey} updateJourney={updateJourney} selectedTrip={trip}  partyBalance={partyBalance} vendorBalance={vendorBalance} open={addOpen} onClose={handleaddTripActionClose} onSave={handleActionSave} />}
      {editOpen && <JourneyTripActionDialog action={editPartyPayment} journey={journey} updateJourney={updateJourney} selectedTrip={trip} editData={transactionData} open={editOpen} onClose={handleEditCashflowActionClose} onUpdateSuccess={handleOnUpdateSuccess} confirmText={editPartyPayment.confirmText ? editPartyPayment.confirmText : null} />}
      {deleteOpen && <DeletePartyPayment deleteOpen={deleteOpen} tripId={tripId} deleteId={transactionData.id} onDeleteSucees={onDeleteSuccess} onDeleteNo={onDeleteCancel} />}
      {deletePartyPaymentInitiated && <DeletePartyPaymentInitiated paymentData={numberFormat(Math.abs(transactionData.amount))} open={deletePartyPaymentInitiated} deleteId={transactionData.customerPaymentId} onClose={handlePaymentInitiatedClose} onDeleteConfirm={handlePaymentInitiatedConfirm} />}
      {detailsOpen && <TransactionDetailsSideBar
                sideBarTitle="details-side-bar"
                rightSideBarOpen={detailsOpen}
                sideBarTitle={'Party Payment Details'}
                data={transactionData}
                cStyle={true}
                onEdit={(!transactionData || tripStatus == 'PAYMENT_RECEIVED' || (transactionData && !transactionData.id) || (transactionData && transactionData.isBrokerEnabled)) ? null :(data) => {
                  setEditOpen(true)
                } }
                onDelete={(!transactionData || tripStatus == 'PAYMENT_RECEIVED' || (transactionData && !transactionData.id) || (transactionData && transactionData.isBrokerEnabled)) ?
                transactionData && transactionData.customerPaymentId&&transactionData.paymentLinkStatus&&transactionData.paymentLinkStatus=='ACTIVE'?(data)=>{
                  setDeletePartyPaymentInitiated(true)
                }:null: (data) => {
                   setDeleteOpen(true)
                }}
                //sideBarSecondaryTitle={null}
                handleSubmit={event => { }}
                toggleRightSideBar={handleTransactionDetailsClose}
            >
                <TripTransactionDetailsCard
                    journey={journey} 
                    updateJourney={updateJourney} 
                    trip={trip}
                    data={transactionData}
                    type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                />
            </TransactionDetailsSideBar>}
    </>
  );
}
export default JourneyTripPaymentsCard;